import { gql } from '@apollo/client';

const userCommentAccessibilityOptionsFragment = gql`
  fragment UserCommentAccessibilityOptionsFields on CommentAccessibilities {
    Title
    TargetUserId
    Accessibility
  }
`;

export default userCommentAccessibilityOptionsFragment;
